// stage
export const INTRO_STAGE = "INTRO_STAGE";
export const PLAY_STAGE = "PLAY_STAGE";
export const FINISH_STAGE = "FINISH_STAGE";

export const BALLOON_STAGE = "BALLOON_STAGE";
export const BASKET_STAGE = "BASKET_STAGE";
export const CLOUD_STAGE = "CLOUD_STAGE";
